import React, {useState, useEffect, useMemo}		from 'react';
import {useNavigate, useParams}						from 'react-router-dom';
import moment										from 'moment';

import Devices										from '../Devices';
import Modal										from '../../ressources/components/Modal';
import Button										from '../../ressources/components/Button';
import Icon											from '../../ressources/components/Icon';
import Tabs											from '../../ressources/components/Tabs';
import ButtonStickyContainer						from '../../ressources/components/Button/ButtonStickyContainer';
import Switch										from '../../ressources/components/Switch';
import Checkbox										from '../../ressources/components/Checkbox';
import Badge										from '../../ressources/components/Badge';
import DeviceImage									from '../../ressources/components/Device/DeviceImage';
import Load											from '../../ressources/components/Load';
import MultiInputContainer							from '../../ressources/components/Input/MultiInputContainer';
import Section										from '../../ressources/components/Section';
import {DeviceCard}									from '../../ressources/components/Device';
import Input										from '../../ressources/components/Input';
import Select										from '../../ressources/components/Select';
import {InputValues}								from '../../ressources/components/Input/interface';
import {SelectValues}								from '../../ressources/components/Select/interface';
import Textarea										from '../../ressources/components/Textarea';
import UsersModalAssignDevice						from '../../Users/UserAssignDevice';
import ModalAssign									from '../../ressources/components/ModalAssign';

import {useAppDispatch, useAppSelector}				from '../../app/hooks';
import {LanguageType}								from '../../ressources/language/type';
import {clearHeader, setHeader}						from '../../redux/settings/settings';
import {DevicesState, PutDeviceData}				from '../../redux/devices/interface';
import {MdmDevice, MdmFullDeviceData}				from '../../redux/devices/interfaceMdm';
import {getDevicesApi, getMdmDevicesApi,
	postDevicesApi, putDevicesApi}					from '../../redux/devices/devices';
import {DEVICE_TYPE, LOCATION_TYPE, STATE}			from '../../ressources/data/form';
import {KEYBOARD_LIST}								from '../../ressources/data/device';

import {ft_genNotification, ft_pushNotification} 	from '../../ressources/functions/notification';
import {ft_setVarText}								from '../../ressources/functions/text';
import {ft_getDeviceType, ft_getDeviceTypeName}		from '../../ressources/functions/deviceFunction';
import {ft_formatBytes, ft_formatPrice}				from '../../ressources/functions/format';
import ft_cssVar									from '../../ressources/functions/getCssVar';
import {ft_selectDataGetMemory, ft_selectDataGetNetwork,
	ft_selectDataGetStockage, ft_selectDataString,
	ft_selectDataUser, ft_selectPlaceholderUser}	from '../../ressources/functions/selectData';
import {ft_findUser}								from '../../ressources/functions/userFunction';

import img_computer									from '../../ressources/images/icon/devices/computer.svg';
import img_infoCircle								from '../../ressources/images/icon/info-circle.svg';
import img_eye										from '../../ressources/images/icon/eye-open.svg';
import img_chevronRight								from '../../ressources/images/icon/arrow/chevron-right.svg';
import img_link										from '../../ressources/images/icon/link.svg';

import LANGUAGE										from '../../ressources/language';
import * as API										from '../../ressources/API';

import './Mdm.css';

interface ImportList {
	serial: string,
	action?: string,
	deviceId?: string
	data: {
		name: InputValues,
		state: SelectValues,
		purchaseType: SelectValues,
		deviceType: SelectValues,
		funder: InputValues,
		contractStart: InputValues,
		contractEnd: InputValues,
		duration: InputValues,
		price: InputValues,
		contractNumber: InputValues,
		billingNumber: InputValues,

		serial: InputValues,
		imei: InputValues,
		internalId: InputValues,
		brand: InputValues,
		screenSize: InputValues,
		stockage: SelectValues,
		memory: SelectValues,
		processor: InputValues,
		graphicCard: InputValues,
		network: SelectValues,
		gpu: InputValues,
		keyboard: SelectValues,
		description: InputValues,
		assign?: string
	},
}

const emptyDeviceData: ImportList['data'] = {
	name:           '',
	state:          '',
	purchaseType:   '',
	deviceType:     '',
	funder:         '',
	contractStart:  '',
	contractEnd:    '',
	duration:       '',
	price:          '',
	contractNumber: '',
	billingNumber:  '',
	serial:         '',
	imei:           '',
	internalId:     '',
	brand:          '',
	screenSize:     '',
	stockage:       '',
	memory:         '',
	processor:      '',
	graphicCard:    '',
	network:        '',
	gpu:            '',
	keyboard:       '',
	description:    ''
};


function DevicesMdm() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const devices = useAppSelector(state => state.devices.data);
	const mdmDevices = useAppSelector(state => state.devices.mdm);
	const lang = useAppSelector(state => state.settings.lang);
	const userReload = useAppSelector(state => state.user.reload);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [deviceView, set_deviceView] = useState('');
	const [modal, set_modal] = useState<string | null>(null);
	const [deviceFullData, set_deviceFullData] = useState<MdmFullDeviceData>();

	// --- Import
	const [step, set_step] = useState(1);
	const [hideEnroll, set_hideEnroll] = useState(true);
	const [hideDontImport, set_hideDontImport] = useState(false);
	const [importList, set_importList] = useState<ImportList[]>([]);
	const [step3Index, set_step3Index] = useState(0);
	const [modalAssign, set_modalAssign] = useState(false);

	const [load, set_load] = useState(false);

	const navigate = useNavigate();
	const params = useParams();
	const TEXTE = LANGUAGE(lang);

	const actualMdm = useMemo(() => {
		return params.name as keyof DevicesState['mdm'];
	}, [params.name]);

	const enrollCount = useMemo(() => (
		mdmDevices[actualMdm].filter(mdm => devices.some(device => device.serial === mdm.serial)).length
	), [devices, mdmDevices, actualMdm]);

	useEffect(() => {
		dispatch(getMdmDevicesApi({name: actualMdm, user}));
		dispatch(getDevicesApi(user));

		API.getMdm(user)
		.then((response) => {
			if (!response?.data?.some((find: string) => find === params.name))
				return navigate('/devices/mdm');
		});
	}, [userReload]);

	useEffect(() => {
		if (!deviceView)
			return;
		dispatch(setHeader({
			function: () => set_deviceView(''),
			render:   TEXTE.devices.mdm.backToMdm
		}));

		return () => {
			dispatch(clearHeader());
		};
	}, [deviceView]);

	useEffect(() => {
		if (step !== 3)
			return;

		const index = mdmDevices[actualMdm].findIndex(find => find.serial === importList[step3Index]?.serial);

		if (index !== -1)
			return getAllData(mdmDevices[actualMdm][index]);
	}, [step, step3Index]);

	useEffect(selectAllImport, [devices, mdmDevices[actualMdm]]);

	async function addDevice() {
		let successCount = 0;
		set_load(true);

		await Promise.all(importList.map(importData =>
			new Promise((resolve) => {
				if (importData.action === 'dontImport')
					return;

				const isPut = (importData.action === 'existingDevice' && importData.deviceId);
				let contractEnd;

				if (importData.data.purchaseType === 'lease' && importData.data.contractStart && importData.data.duration)
					contractEnd = moment(importData.data.contractStart, 'DD/MM/YYYY').add(importData.data.duration, 'month').format('DD/MM/YYYY');
				else if (importData.data.purchaseType !== 'lease')
					contractEnd = importData.data.contractEnd;

				const apiData: PutDeviceData = {
					name:           importData.data.name,
					assign:         importData.data.assign,
					serial:         importData.data.serial,
					funder:         importData.data.funder,
					keyboard:       importData.data.keyboard,
					processor:      importData.data.processor,
					deviceType:     importData.data.deviceType,
					screenSize:     importData.data.screenSize,
					graphicCard:    importData.data.graphicCard,
					description:    importData.data.description,
					purchaseType:   importData.data.purchaseType,
					billingNumber:  importData.data.billingNumber,
					contractNumber: importData.data.contractNumber,
					state:          importData.data.state as string,
					network:        importData.data.network as string,
					memory:         importData.data.memory?.toString(),
					stockage:       importData.data.stockage?.toString(),
					price:          parseFloat(importData.data.price as string),
					duration:       parseInt(importData.data.duration as string, 10),
					locationEnd:    contractEnd ? moment(contractEnd, 'DD/MM/YYYY').toDate() : undefined,
					locationStart:  importData.data.contractStart ? moment(importData.data.contractStart, 'DD/MM/YYYY').toDate() : undefined
				};

				// --- Post Device
				if (!isPut && importData.action !== 'create')
					return resolve(true);

				if (isPut) {
					const actualDevice = devices.find(find => find._id === importData.deviceId);

					if (actualDevice)
						apiData.assign = typeof actualDevice.user === 'object' ? actualDevice.user?._id : actualDevice.user;
				}

				dispatch(
					isPut ?
						putDevicesApi({idDevice: importData.deviceId, data: apiData, user})
						:
						postDevicesApi({data: apiData, user})
				)
				.then((response) => {
					if (!response.payload.status) {
						const notificationData = ft_genNotification(TEXTE, 'error', img_computer, response.payload.error);
						notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
					} else
						successCount++;
					resolve(true);
				});
			})
		));

		const notificationData = ft_genNotification(TEXTE, 'addMultipleDevicesSuccess', img_computer, successCount.toString());
		notificationId = ft_pushNotification(dispatch, notificationId, notificationData);

		set_load(false);
		navigate('/devices/mdm');
	}

	function checkStepIsValid(): boolean {
		if (step >= 2 && importList.length === 0)
			return false;
		if (step === 3 && importList.some(find => !find.action))
			return false;
		if (step === 4 && importList.filter(find => find.action !== 'dontImport').length === 0)
			return false;
		return true;
	}

	function selectAllImport() {
		const newImportList: ImportList[] = [];

		mdmDevices[actualMdm].forEach((mdm) => {
			if (!devices.some(device => device.serial === mdm.serial))
				newImportList.push({serial: mdm.serial, data: {...emptyDeviceData}});
		});

		set_importList(newImportList);
	}

	function getAllData(mdmDevice: MdmDevice, isModal?: boolean) {
		if (actualMdm === 'jamf') {
			if (!mdmDevice?.serial || !mdmDevice.id || !mdmDevice.type)
				return;

			set_load(true);
			set_deviceFullData(undefined);
			if (isModal)
				set_modal('allData');

			API.getMdmDeviceAllDataJamf(mdmDevice.id, mdmDevice.serial, mdmDevice.type, user)
			.then((response) => {
				set_load(false);
				if (!response?.data || !response.status)
					return set_modal(null);

				set_deviceFullData(response.data);

				if (step === 3 && importList?.[step3Index]?.data && !importList[step3Index].data.name) {
					const data: MdmFullDeviceData = response.data;
					const copy = [...importList];

					if (data.computer) {
						copy[step3Index].data.name = data.computer.model;
						copy[step3Index].data.deviceType = 'computer';
						copy[step3Index].data.serial = data.computer.serial_number;
						copy[step3Index].data.brand = data.computer.make || '';
						copy[step3Index].data.processor = data.computer.processor_type || '';
						copy[step3Index].data.gpu = data.computer.number_cores || '';
						copy[step3Index].data.keyboard = 'Français - AZERTY';
						if (data.computer.total_ram)
							copy[step3Index].data.memory = ft_formatBytes(parseInt(data.computer.total_ram, 10), 'MB').replace('B', 'o');

						if (data.computer.model?.includes('-inch')) {
							const split = data.computer.model.split('-inch');
							copy[step3Index].data.screenSize = parseInt(split[0].replace(/\D/g, ''), 10);
						}
					} else if (data.mobile) {
						copy[step3Index].data.name = data.mobile.model;
						copy[step3Index].data.deviceType = data.mobile.model?.includes('iPad') ? 'tablet' : 'phone';
						copy[step3Index].data.serial = data.mobile.serial_number || '';
						copy[step3Index].data.imei = data.mobile.imei;
						copy[step3Index].data.brand = 'Apple';
						if (data.mobile.capacity_mb)
							copy[step3Index].data.stockage = ft_formatBytes(parseInt(data.mobile.capacity_mb, 10), 'MB').replace('B', 'o');
					}

					copy[step3Index].data.purchaseType = 'purchase';
				}
			});
		} else if (actualMdm === 'vmWare') {
			if (isModal)
				set_modal('allData');

			if (step === 3 && importList?.[step3Index]?.data && !importList[step3Index].data.name) {
				const data: MdmFullDeviceData = {};

				if (mdmDevice.type === 'computer') {
					data.computer = {
						name:          mdmDevice.name,
						serial_number: mdmDevice.serial,
						model:         mdmDevice.model
					};
				}

				set_deviceFullData(data);

				const copy = [...importList];

				copy[step3Index].data.name = mdmDevice.name;
				copy[step3Index].data.serial = mdmDevice.serial || '';

				if (mdmDevice.fullData?.user || mdmDevice.fullData?.email)
					copy[step3Index].data.assign = ft_findUser(users, mdmDevice.fullData.user || mdmDevice.fullData.email);

				if (data.computer) {
					copy[step3Index].data.deviceType = 'computer';
					// copy[step3Index].data.memory = ft_formatBytes(parseInt(data.computer.total_ram, 10), 'MB').replace('B', 'o');
					copy[step3Index].data.keyboard = 'Français - AZERTY';
				} else if (data.mobile) {
					copy[step3Index].data.deviceType = data.mobile.model.includes('iPad') ? 'tablet' : 'phone';
					copy[step3Index].data.imei = data.mobile.imei;
					if (data.mobile.capacity_mb)
						copy[step3Index].data.stockage = ft_formatBytes(parseInt(data.mobile.capacity_mb, 10), 'MB').replace('B', 'o');
				}

				copy[step3Index].data.purchaseType = 'purchase';
			}
		}
	}

	function renderImportHeader() {
		return (
			<div className={'globalDataContainerItem column'}>
				<span className={'text-lg weight-600'}>{ft_setVarText(TEXTE.devices.mdm.syncWithValala, TEXTE.component.externalApi[actualMdm])}</span>
				<Tabs
					step
					actual={step}
					onChange={val => set_step(val as number)}
					data={[
						{value: 1, render: TEXTE.devices.mdm.informations},
						{value: 2, render: TEXTE.devices.mdm.correspondence},
						{value: 3, render: TEXTE.devices.mdm.otherDevices},
						{value: 4, render: TEXTE.devices.mdm.validate}
					]}
				/>
			</div>
		);
	}

	function renderImportStep1() {
		const renderItem = (title: keyof LanguageType['devices']['mdm'], text: keyof LanguageType['devices']['mdm']) => {
			return (
				<div className={'mdmInformationContainerItem'}>
					<Icon
						iconBorder
						borderSize={0}
						icon={img_infoCircle}
					/>
					<div>
						<span className={'text-md weight-600 gray-700'}>{ft_setVarText(TEXTE.devices.mdm[title] as string, actualMdm)}</span>
						<span className={'text-md gray-600'}>{ft_setVarText(TEXTE.devices.mdm[text] as string, actualMdm, actualMdm)}</span>
					</div>
				</div>
			);
		};

		return (
			<div>
				{renderItem('howSyncWork', 'howSyncWorkText')}
				{renderItem('whatDataImported', 'whatDataImportedText')}
				{renderItem('syncLater', 'syncLaterText')}
			</div>
		);
	}

	function renderImportStep2() {
		const renderTable: React.ReactElement[] = [];

		mdmDevices[actualMdm].forEach((mdmDevice, i) => {
			const onClick = () => {
				if (isEnroll)
					return;

				const copy = [...importList];
				const index = copy.findIndex(find => find.serial === mdmDevice.serial);

				if (index === -1)
					copy.push({serial: mdmDevice.serial, data: {...emptyDeviceData}});
				else
					copy.splice(index, 1);

				set_importList(copy);
			};
			const isEnroll = devices.find(device => device.serial === mdmDevice.serial);

			if (hideEnroll && isEnroll)
				return;

			const checked = !isEnroll && importList.some(find => find.serial === mdmDevice.serial);

			renderTable.push(
				<tr
					key={`mdmDevice-${i}`}
					onClick={onClick}
					style={{cursor: isEnroll ? 'default' : 'pointer'}}
					className={checked ? 'tableRow selected' : ''}
				>
					<td>
						<div className={'flex-center'}>
							{!isEnroll &&
								<Checkbox active={checked} />
							}
						</div>
					</td>
					<td>{mdmDevice.model}</td>
					<td>{ft_getDeviceTypeName(TEXTE, mdmDevice.type)}</td>
					<td>{mdmDevice.serial}</td>
					<td>
						<Badge
							size={'sm'}
							color={isEnroll ? 'success' : 'warning'}
							text={TEXTE.global[isEnroll ? 'yes' : 'no']}
						/>
					</td>
					<td>
						<div
							onClick={(e) => {
								e.stopPropagation();
								if (isEnroll)
									return set_deviceView(isEnroll._id);
								getAllData(mdmDevice, true);
							}}
						>
							<Icon icon={img_eye} />
						</div>
					</td>
				</tr>
			);
		});

		return (
			<div>
				<div className={'mdmInformationContainerItem'}>
					<Icon
						iconBorder
						borderSize={0}
						icon={img_infoCircle}
					/>
					<div>
						<span className={'text-md weight-600 gray-700'}>
							{`${enrollCount}/${mdmDevices[actualMdm].length} ${ft_setVarText(TEXTE.devices.mdm.devicesCorrespondence, actualMdm)}`}
						</span>
						<Switch
							text={TEXTE.devices.mdm.selectEnroll}
							active={importList.length === enrollCount}
							onChange={val => (val ? selectAllImport() : set_importList([]))}
						/>
						<Switch
							active={hideEnroll}
							onChange={set_hideEnroll}
							text={ft_setVarText(TEXTE.devices.mdm.hideEnroll, actualMdm)}
						/>
					</div>
				</div>

				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th style={{width: 50}} />
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.global.deviceType}</th>
							<th>{TEXTE.global.serial}</th>
							<th>{TEXTE.devices.mdm.enroll}</th>
							<th style={{width: 50}}>{TEXTE.global.see}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>
			</div>
		);
	}

	function renderImportStep3() {
		const onClick = (action: string) => {
			const copy = [...importList];

			copy[step3Index].action = action;

			set_importList(copy);
		};
		const action = importList[step3Index].action;

		return (
			<div>
				<Section className={'mdmInformationContainerItem'}>
					<Icon
						iconBorder
						borderSize={0}
						icon={img_infoCircle}
					/>
					<div>
						<span className={'text-md weight-600 gray-700'}>
							{`${enrollCount}/${mdmDevices[actualMdm].length} ${ft_setVarText(TEXTE.devices.mdm.devicesCorrespondence, actualMdm)}`}
						</span>
					</div>
				</Section>

				<Section title={ft_setVarText(TEXTE.devices.mdm.deviceDetects, TEXTE.component.externalApi[actualMdm])}>
					{renderAllDataContainer()}
				</Section>

				<div className={'flex flex-center'}>
					<Icon className={'mdmLinkIcon'} icon={img_link} />
				</div>

				<Section
					title={TEXTE.devices.mdm.noMatch}
					className={'weight-600 gray-600'}
				>
					{importList[step3Index].deviceId ?
						<>
							<DeviceCard
								assignReadOnly
								checkbox={'round'}
								onClick={() => onClick('existingDevice')}
								selected={action === 'selectDevice' || action === 'existingDevice'}
								device={devices.find(find => find._id === importList[step3Index].deviceId)}
							/>

							<div className={'mdmActionExistingDeviceText'}>
								<Icon
									iconBorder
									size={20}
									iconSize={14}
									borderSize={0}
									type={'warning'}
									icon={img_infoCircle}
									iconColor={ft_cssVar('warning-600')}
									style={{transform: 'rotate(180deg)'}}
								/>
								<span className={'flex text-xs weight-400'}>{ft_setVarText(TEXTE.devices.mdm.supersededBy, actualMdm)}</span>
								<span
									className={'weight-500 primary-600'}
									onClick={() => onClick('selectDevice')}
								>
									{TEXTE.devices.mdm.editSelection}
								</span>
							</div>
						</>
						:
						<div
							onClick={() => onClick('selectDevice')}
							className={`mdmSelectActionContainer ${(action === 'selectDevice' || action === 'existingDevice') && 'active'}`}
						>
							<span className={'flex'}>{TEXTE.devices.mdm.selectFromInventory}</span>
							<div className={'mdmSelectActionContainerIcon'}>
								<Icon icon={img_chevronRight} />
							</div>
						</div>
					}

					<div
						onClick={() => {
							onClick('create');
							set_modal('add-detail');
						}}
						className={`mdmSelectActionContainer ${action === 'create' && 'active'}`}
					>
						<Checkbox active={action === 'create'} round />
						<div className={'mdmSelectActionContainerText'}>
							<span>{TEXTE.devices.mdm.createDevice}</span>
							<br />
						</div>
					</div>

					<div
						onClick={() => onClick('dontImport')}
						className={`mdmSelectActionContainer ${action === 'dontImport' && 'active'}`}
					>
						<Checkbox active={action === 'dontImport'} round />
						<div className={'mdmSelectActionContainerText'}>
							<span>{TEXTE.devices.mdm.dontImport}</span>
							<span className={'weight-400'}>{ft_setVarText(TEXTE.devices.mdm.deviceWillNotBeLinked, actualMdm)}</span>
						</div>
					</div>
				</Section>

				<MultiInputContainer style={{alignItems: 'center'}} >
					<Button
						iconOnly
						type={'tertiary-gray'}
						icon={img_chevronRight}
						disabled={step3Index <= 0}
						style={{transform: 'rotate(180deg)'}}
						onClick={() => set_step3Index(step3Index - 1)}
					/>
					<span className={'text-md weight-600 gray-900'}>{`${step3Index + 1}/${importList.length}`}</span>
					<Button
						iconOnly
						type={'tertiary-gray'}
						icon={img_chevronRight}
						onClick={() => set_step3Index(step3Index + 1)}
						disabled={step3Index + 1 >= importList.length}
					/>
				</MultiInputContainer>
			</div>
		);
	}

	function renderImportStep4() {
		const renderTable: React.ReactElement[] = [];

		importList.forEach((device, i) => {
			if (hideDontImport && device.action === 'dontImport')
				return;

			let badgeText = TEXTE.global.no;

			if (device.action === 'existingDevice')
				badgeText = TEXTE.devices.mdm.selection;
			if (device.action === 'create')
				badgeText = TEXTE.devices.mdm.creation;

			renderTable.push(
				<tr key={`mdmDevice-import-${i}`}>
					<td>{device.data.name}</td>
					<td>{ft_getDeviceTypeName(TEXTE, device.data.deviceType as string)}</td>
					<td>{device.data.serial}</td>
					<td>
						<Badge
							size={'sm'}
							text={badgeText}
							color={device.action !== 'dontImport' ? 'success' : 'error'}
						/>
					</td>
				</tr>
			);
		});

		return (
			<div>
				<div className={'mdmInformationContainerItem'}>
					<Icon
						iconBorder
						borderSize={0}
						icon={img_infoCircle}
					/>
					<div>
						<span className={'text-md weight-600 gray-700'}>
							{ft_setVarText(TEXTE.devices.mdm.recap, importList.filter(e => e.action !== 'dontImport').length, actualMdm)}
						</span>
						<Switch
							active={hideDontImport}
							onChange={set_hideDontImport}
							text={TEXTE.devices.mdm.hideDontImport}
						/>
					</div>
				</div>

				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.global.deviceType}</th>
							<th>{TEXTE.global.serial}</th>
							<th>{TEXTE.devices.mdm.enrollment}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>
			</div>
		);
	}

	function renderAllDataContainer() {
		const check = (name: keyof LanguageType['devices']['mdm']['deviceFullData'], value?: string) => {
			if (!value)
				return;

			render.push(
				<div className={'text-xs weight-700 gray-500'}>
					<span>{TEXTE.devices.mdm.deviceFullData[name]}<span className={'weight-400'}>{` : ${value}`}</span></span>
				</div>
			);
		};
		const render: React.ReactElement[] = [];

		if (deviceFullData?.mobile) {
			check('model', deviceFullData.mobile.model);
			check('model_identifier', deviceFullData.mobile.model_identifier);
			check('serial_number', deviceFullData.mobile.serial_number);
			check('wifi_mac_address', deviceFullData.mobile.wifi_mac_address);
			check('bluetooth_mac_address', deviceFullData.mobile.bluetooth_mac_address);
			if (deviceFullData.mobile.capacity_mb)
				check('capacity_mb', ft_formatBytes(parseInt(deviceFullData.mobile.capacity_mb, 10), 'MB'));
			check('battery_level', deviceFullData.mobile.battery_level);
		} else if (deviceFullData?.computer) {
			check('make', deviceFullData.computer.make);
			check('model', deviceFullData.computer.model);
			check('model_identifier', deviceFullData.computer.model_identifier);
			check('serial_number', deviceFullData.computer.serial_number);
			check('processor_speed', deviceFullData.computer.processor_speed);
			check('number_processors', deviceFullData.computer.number_processors);
			check('number_cores', deviceFullData.computer.number_cores);
			check('processor_type', deviceFullData.computer.processor_type);
			if (deviceFullData.computer.is_apple_silicon)
				check('is_apple_silicon', TEXTE.global[deviceFullData.computer.is_apple_silicon ? 'yes' : 'no']);
			check('processor_architecture', deviceFullData.computer.processor_architecture);
			check('bus_speed', deviceFullData.computer.bus_speed);
			if (deviceFullData.computer.cache_size)
				check('cache_size', ft_formatBytes(parseInt(deviceFullData.computer.cache_size, 10), 'KB'));
			check('network_adapter_type', deviceFullData.computer.network_adapter_type);
			check('mac_address', deviceFullData.computer.mac_address);
			check('alt_mac_address', deviceFullData.computer.alt_mac_address);
			if (deviceFullData.computer.total_ram)
				check('total_ram', ft_formatBytes(parseInt(deviceFullData.computer.total_ram, 10), 'MB'));
			check('available_ram_slots', deviceFullData.computer.available_ram_slots);
			if (deviceFullData.computer.battery_capacity)
				check('battery_capacity', `${deviceFullData.computer.battery_capacity}%`);
			check('smc_version', deviceFullData.computer.smc_version);
			check('nic_speed', deviceFullData.computer.nic_speed);
			check('optical_drive', deviceFullData.computer.optical_drive);
			check('boot_rom', deviceFullData.computer.boot_rom);
		}

		return (
			<div className={'globalDataContainerItem column'}>
				<div className={'mdmAllDataModalTitle'}>
					<DeviceImage
						size={40}
						className={'deviceCardImg'}
						forceType={deviceFullData?.mobile ? 'mobile' : 'computer'}
					/>
					<span className={'weight-600 gray-900'}>{deviceFullData?.mobile?.modelDisplay || deviceFullData?.computer?.model}</span>
				</div>

				<div className={'mdmAllDataModalContainer'}>
					{render}
					<div />
					<div />
					<div />
					<div />
				</div>
				{load && <Load center />}
			</div>
		);
	}

	function renderButtonContainer() {
		return (
			<ButtonStickyContainer>
				<Button
					fullWidth
					disabled={load}
					type={'tertiary-gray'}
					onClick={() => (step === 1 ? navigate(`/devices/mdm/${actualMdm}`) : set_step(step - 1))}
				>
					{step === 1 ? TEXTE.global.cancel : TEXTE.global.previous}
				</Button>

				<Button
					fullWidth
					isLoad={load}
					disabled={!checkStepIsValid()}
					onClick={() => (step < 4 ? set_step(step + 1) : addDevice())}
				>
					{step === 4 ? TEXTE.global.validAndSave : TEXTE.global.next}
				</Button>
			</ButtonStickyContainer>
		);
	}

	function renderAllDataModal() {
		return (
			<Modal
				size={1300}
				onClose={() => set_modal(null)}
				header={ft_setVarText(TEXTE.devices.mdm.deviceDetects, TEXTE.component.externalApi[actualMdm])}
			>
				{renderAllDataContainer()}
			</Modal>
		);
	}

	function renderAddModal() {
		const deviceData = importList?.[step3Index]?.data;

		if (!deviceData)
			return;

		const onClose = () => {
			set_modal(null);

			if (step3Index + 1 < importList.length)
				set_step3Index(step3Index + 1);
		};
		const onChange = (name: keyof ImportList['data'], value: InputValues) => {
			const copy = [...importList];

			if (name === 'assign')
				copy[step3Index].data[name] = value as string;
			else
				copy[step3Index].data[name] = value;

			set_importList(copy);
		};

		return (
			<>
				<Modal
					size={654}
					onClose={onClose}
					confirmButton={onClose}
					confirmButtonText={TEXTE.global.confirm}
				>
					<Tabs
						actual={modal}
						onChange={val => set_modal(val as string)}
						data={[
							{value: 'add-detail', render: TEXTE.global.details},
							{value: 'add-characteristic', render: TEXTE.global.characteristic}
						]}
					/>

					{modal === 'add-detail' &&
						<div className={'contractAddDeviceModalContainer'}>
							<Input
								required
								searchAbsolute
								onChange={val => onChange('name', val)}
								value={deviceData.name}
								title={TEXTE.devices.deviceName}
								placeholder={'ex : MacBook Air M1 13"'}
							/>

							<Select
								value={deviceData.assign}
								title={TEXTE.global.affect}
								data={ft_selectDataUser(users)}
								onClick={() => set_modalAssign(true)}
								placeholder={ft_selectPlaceholderUser(TEXTE)}
							/>

							<MultiInputContainer>
								<Select
									required
									data={LOCATION_TYPE(TEXTE)}
									value={deviceData.purchaseType}
									title={TEXTE.global.purchaseType}
									onChange={val => onChange('purchaseType', val as InputValues)}
								/>
								<Select
									readOnly
									data={DEVICE_TYPE(TEXTE)}
									value={deviceData.deviceType}
									title={TEXTE.global.deviceType}
								/>
							</MultiInputContainer>

							<MultiInputContainer>
								<Input
									value={deviceData.funder}
									title={TEXTE.global.supplier}
									placeholder={'Apple Pro Services'}
									onChange={val => onChange('funder', val)}
								/>
								<Input
									type={'date'}
									value={deviceData.contractStart}
									required={deviceData.purchaseType === 'lease'}
									onChange={val => onChange('contractStart', val)}
									placeholder={moment().startOf('month').format('DD/MM/YYYY')}
									title={(deviceData.purchaseType === 'lease') ? TEXTE.global.contractStart : TEXTE.global.purchaseDate}
								/>

							</MultiInputContainer>

							{(deviceData.purchaseType === 'lease') &&
								<MultiInputContainer>
									<Input
										required
										min={1}
										type={'number'}
										value={deviceData.duration}
										title={TEXTE.global.duration}
										placeholder={`24 ${TEXTE.global.month}`}
										onChange={val => onChange('duration', val)}
										notFocusValue={deviceData.duration ? `${deviceData.duration} ${TEXTE.global.month}` : undefined}
									/>
									<Input
										readOnly
										title={TEXTE.global.contractEnd}
										value={(deviceData.contractStart && deviceData.duration) ? moment(deviceData.contractStart, 'DD/MM/YYYY').add(deviceData.duration, 'month').format('DD/MM/YYYY') : ''}
									/>
								</MultiInputContainer>
							}

							<MultiInputContainer>
								<Input
									min={0}
									type={'number'}
									value={deviceData.price}
									placeholder={ft_formatPrice('24')}
									onChange={val => onChange('price', val)}
									notFocusValue={deviceData.price ? ft_formatPrice(deviceData.price) : undefined}
									title={(deviceData.purchaseType === 'lease') ? TEXTE.global.monthlyPrice : TEXTE.devices.purchasePrice}
								/>
								{(deviceData.purchaseType === 'lease') ?
									<Input
										value={deviceData.contractNumber}
										onChange={val => onChange('contractNumber', val)}
										title={TEXTE.global.contractNumber}
										placeholder={'123456'}
									/>
									:
									<Input
										type={'date'}
										value={deviceData.contractEnd}
										onChange={val => onChange('contractEnd', val)}
										title={TEXTE.global.warrantyEnd}
										placeholder={moment().startOf('month').add(1, 'month').format('DD/MM/YYYY')}
									/>
								}
							</MultiInputContainer>

							{(deviceData.purchaseType === 'purchase') &&
								<Input
									value={deviceData.billingNumber}
									placeholder={'123456'}
									onChange={val => onChange('billingNumber', val)}
									title={TEXTE.global.billingNumber}
								/>
							}
						</div>
					}

					{modal === 'add-characteristic' &&
						<div className={'contractAddDeviceModalContainer'}>
							<MultiInputContainer>
								<Input
									readOnly
									value={deviceData.serial}
									title={TEXTE.global.serial}
								/>
								<Input
									value={deviceData.internalId}
									title={TEXTE.global.internalId}
									onChange={val => onChange('internalId', val)}
								/>
							</MultiInputContainer>

							<MultiInputContainer>
								<Input
									value={deviceData.brand}
									title={TEXTE.global.brand}
									onChange={val => onChange('brand', val)}
								/>
								<Input
									readOnly
									value={deviceData.name}
									title={TEXTE.global.name}
								/>
							</MultiInputContainer>

							<MultiInputContainer>
								<Input
									title={TEXTE.global.screenSize}
									onChange={val => onChange('screenSize', val)}
									notFocusValue={deviceData.screenSize ? `${deviceData.screenSize}"` : undefined}
								/>
								<Select
									data={STATE(TEXTE)}
									value={deviceData.state}
									title={TEXTE.global.state}
									onChange={val => onChange('state', val as string)}
								/>
							</MultiInputContainer>
							<MultiInputContainer>
								<Select
									value={deviceData.stockage}
									title={TEXTE.global.stockage}
									data={ft_selectDataGetStockage()}
									onChange={val => onChange('stockage', val as string)}
								/>
								<Select
									value={deviceData.memory}
									title={TEXTE.global.memory}
									data={ft_selectDataGetMemory()}
									onChange={val => onChange('memory', val as InputValues)}
								/>
							</MultiInputContainer>
							<MultiInputContainer>
								<Input
									value={deviceData.processor}
									title={TEXTE.global.processor}
									onChange={val => onChange('processor', val)}
								/>
								{(deviceData.deviceType === 'computer') &&
									<Input
										value={deviceData.graphicCard}
										title={TEXTE.global.graphicCard}
										onChange={val => onChange('graphicCard', val)}
									/>
								}
							</MultiInputContainer>
							<MultiInputContainer>
								<Select
									value={deviceData.network}
									title={TEXTE.global.network}
									data={ft_selectDataGetNetwork()}
									onChange={val => onChange('network', val as string)}
								/>
								{(deviceData.deviceType === 'computer') &&
									<Input
										value={deviceData.gpu}
										title={TEXTE.global.gpu}
										onChange={val => onChange('gpu', val)}
									/>
								}
							</MultiInputContainer>

							{deviceData.deviceType === 'computer' &&
								<Select
									value={deviceData.keyboard}
									onChange={val => onChange('keyboard', val as string)}
									title={TEXTE.global.keyboard}
									data={ft_selectDataString(KEYBOARD_LIST)}
								/>
							}

							<Textarea
								style={{height: 156}}
								value={deviceData.description}
								title={TEXTE.global.descriptionAndNote}
								onChange={val => onChange('description', val)}
							/>
						</div>
					}
				</Modal>

				{modalAssign &&
					<ModalAssign
						modalRight
						load={load}
						onClose={() => set_modalAssign(false)}
						actualId={deviceData.assign ? [deviceData.assign] : []}
						onConfirm={(newAssign) => {
							onChange('assign', newAssign as string);
							set_modalAssign(false);
						}}
					/>
				}
			</>
		);
	}

	if (deviceView)
		return <Devices forceId={deviceView} />;

	return (
		<div className={'globalDataContainer'}>
			{renderImportHeader()}
			{step === 1 && renderImportStep1()}
			{step === 2 && renderImportStep2()}
			{step === 3 && renderImportStep3()}
			{step === 4 && renderImportStep4()}
			{renderButtonContainer()}

			{modal === 'allData' && renderAllDataModal()}
			{modal?.startsWith('add-') && renderAddModal()}
			{importList?.[step3Index]?.action === 'selectDevice' &&
				<UsersModalAssignDevice
					modal
					noValidation
					onlyOneSelection
					deviceList={devices.filter(e =>
						e.notValala
						&& ft_getDeviceType(e) === ft_getDeviceType(undefined, importList[step3Index].data.deviceType as string)
					)}
					onClose={() => {
						const copy = [...importList];

						if (copy[step3Index].deviceId)
							copy[step3Index].action = 'existingDevice';
						else
							copy[step3Index].action = '';

						set_importList(copy);
					}}
					onSave={(idList) => {
						const copy = [...importList];

						copy[step3Index].action = 'existingDevice';
						copy[step3Index].deviceId = idList[0];

						set_importList(copy);
					}}
				/>
			}
		</div>
	);
}

export default DevicesMdm;
